import axiosInstance from '../../utils/axiosClient'
import { userAuthStore } from '../../store/auth'
import { toast } from 'react-toastify'

class ApiClient {
  // User endpoints
  // Get user profile
  async getUserProfile() {
    try {
      const response = await axiosInstance.get('user/profile/')
      userAuthStore.getUser().setUser(response.data)
      return { data: response.data }
    } catch (error) {
      return { error: error.response?.data?.detail }
    }
  }

  async updateUserProfile(updatedData) {
    try {
      const response = await axiosInstance.post(`user/profile/`, updatedData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      userAuthStore.getUser().setUser(response.data)
      return { data: response.data }
    } catch (error) {
      return { error: error.response?.data?.detail }
    }
  }

  // Get a particular user profile
  async userProfilePic() {
    try {
      const response = await axiosInstance.get(`user/profile/me/`)
      return { data: response.data }
    } catch (error) {
      return { error: error.response?.data?.detail }
    }
  }

  //============================================================
  // Get all clients
  async getAllClients() {
    try {
      const response = await axiosInstance.get('clients/')
      return { data: response.data }
    } catch (error) {
      console.error('Error getting all clients:', error)
      return { error: error.response?.data?.detail }
    }
  }

  // Get client details
  async getClientDetails(clientId) {
    try {
      const response = await axiosInstance.get(`clients/${clientId}/`)
      return { data: response.data }
    } catch (error) {
      console.error('Error fetching client details:', error)
      return { error: error.response?.data?.detail }
    }
  }

  // Update client (full)
  async updateClientDetails(clientId, name, email, image, programId, status) {
    const formData = new FormData()
    formData.append('client_name', name)
    formData.append('email', email)
    formData.append('program_id', programId)
    formData.append('status', status)
    if (image) {
      formData.append('image', image)
    }

    try {
      const response = await axiosInstance.patch(
        `clients/${clientId}/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      toast.success(`Client "${name}" updated successfully`, {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      return { data: response?.data }
    } catch (error) {
      toast.error('Error updating client', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      console.error('Backend response:', error.response?.data)
      return { error: error.response?.data?.detail }
    }
  }

  // Patch client (partial update)
  // async patchClientDetails(clientId, partialData) {
  //   try {
  //     const response = await axiosInstance.patch(
  //       `clients/${clientId}/`,
  //       partialData
  //     )
  //     return { data: response.data }
  //   } catch (error) {
  //     console.error('Error patching client details:', error)
  //     return { error: error.response?.data?.detail }
  //   }
  // }

  // Create a new client
  async createClient(name, email, image, program) {
    const formData = new FormData()
    formData.append('client_name', name)
    formData.append('email', email)
    formData.append('image', image)
    // formData.append('status', status)
    formData.append('program_id', program)
    try {
      const response = await axiosInstance.post('clients/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      // onClose() // close modal after success
      if (response.data) {
        toast.success(`${name} successfully created!`, {
          position: 'top-right',
          autClose: 3000,
          theme: 'colored',
        })
      }
      return { data: response.data }
    } catch (error) {
      toast.error('Error creating client', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      console.error('Error creating client:', error)
      return { error: error.response?.data?.detail }
    }
  }

  // Delete client
  async deleteClient(clientId) {
    try {
      const response = await axiosInstance.delete(`clients/${clientId}/`)
      toast.success('Client deleted successfully!', {
        postition: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      return { data: response.data }
    } catch (error) {
      toast.error('Error deleting client', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      console.error('Error deleting client:', error)
      return { error: error.response?.data?.detail }
    }
  }

  //==============================================================

  // Fetch client family (only if supported by backend)
  async getClientFamily(clientId) {
    try {
      const response = await axiosInstance.get(
        `clients/${clientId}/family_members/`
      )
      return { data: response.data }
    } catch (error) {
      console.error('Error fetching client family:', error)
      return { error: error.response?.data?.detail }
    }
  }

  // Get a family member
  async getAFamilyMember(memberId) {
    try {
      const response = await axiosInstance.get(`family_members/${memberId}`)
      console.log(response.data)
      return { data: response.data }
    } catch (error) {
      console.log(error.response?.data?.detail)
      return { error: error.response?.data?.detail }
    }
  }

  // Get relationship choices for family members
  async getRelationshipChoices() {
    try {
      const response = await axiosInstance.get(
        'family_members/relationship_choices/'
      )
      return { data: response.data }
    } catch (error) {
      console.error('Error fetching relationship choices:', error)
      // Return default choices if API fails
      return {
        data: [
          { value: 'primary applicant', label: 'Primary Applicant' },
          { value: 'spouse', label: 'Spouse' },
          { value: 'child', label: 'Child' },
          { value: 'relative', label: 'Relative' },
        ],
      }
    }
  }

  // Get avatar choices for family members
  async getAvatarChoices() {
    try {
      const response = await axiosInstance.get('family_members/avatar/')
      return { data: response.data }
    } catch (error) {
      console.error('Error fetching relationship choices:', error)
      // Return default choices if API fails
      return {
        data: [
          'https://c.animaapp.com/etPela4A/img/profile-6@2x.png',
          'https://c.animaapp.com/etPela4A/img/image-1@2x.png',
          'https://c.animaapp.com/etPela4A/img/image-2@2x.png',
          'https://c.animaapp.com/etPela4A/img/image-3@2x.png',
        ],
      }
    }
  }

  // Add family member
  async addFamilyMember(clientId, name, email, image, relationship, age) {
    // Validate required fields
    console.log('=== ADD FAMILY MEMBER DEBUG ===')
    console.log('Input validation:')
    console.log('clientId:', clientId, typeof clientId)
    console.log('name:', name, typeof name)
    console.log('email:', email, typeof email)
    console.log('image:', image, typeof image)
    console.log('relationship:', relationship, typeof relationship)
    console.log('age:', age, typeof age)

    if (!clientId || !name || !relationship || !age) {
      console.error('Missing required fields')
      return { error: 'Missing required fields' }
    }

    // Try sending as JSON first to see if that works
    // const jsonData = {
    //   client: parseInt(clientId),
    //   full_name: name,
    //   relationship: relationship,
    //   birth_date: age,
    // }

    // if (email && email.trim()) {
    //   jsonData.email = email
    // }

    // console.log('Trying JSON approach first:')
    // console.log('JSON data:', jsonData)

    // try {
    //   const response = await axiosInstance.post(
    //     `clients/${clientId}/family_members/`,
    //     jsonData,
    //     {
    //       headers: {
    //         'Content-Type': 'application/json',
    //       },
    //     }
    //   )
    //   console.log('Successfully created family member with JSON')
    //   return { data: response.data }
    // } catch (jsonError) {
    //   console.log('JSON approach failed, trying FormData...')
    //   console.error('JSON error:', jsonError.response?.data)
    // }

    // If JSON fails, try FormData
    const formData = new FormData()
    formData.append('client', clientId)
    formData.append('full_name', name)
    if (email && email.trim()) {
      formData.append('email', email)
    }

    // Only append image if it's a File object (actual upload)
    // Skip URL strings (avatars) as they cause 400 errors
    if (image instanceof File) {
      formData.append('image', image)
    }
    // For avatar URLs, don't send anything - let backend use default

    formData.append('relationship', relationship)
    formData.append('birth_date', age)

    // Log the FormData contents for debugging
    console.log('FormData contents:')
    for (let [key, value] of formData.entries()) {
      console.log(key, value, typeof value)
    }

    try {
      const response = await axiosInstance.post(
        `clients/${clientId}/family_members/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      console.log('Successfully created family member')
      toast.success(`Successfully added ${name}`, {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      return { data: response.data }
    } catch (error) {
      toast.error('Error adding family member', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      console.error('Error creating family member', error)
      console.error('Full error response:', error.response)
      console.error('Error status:', error.response?.status)
      console.error('Error data:', error.response?.data)
      console.error('Error headers:', error.response?.headers)

      return { error: error.response?.data?.detail }
    }
  }

  // Update family member
  async updateFamilyMember(memberId, name, email, image, relationship, age) {
    const formData = new FormData()
    formData.append('full_name', name)
    formData.append('email', email)
    if (image) {
      formData.append('image', image)
    }
    formData.append('relationship', relationship)
    formData.append('birth_date', age)
    try {
      const response = await axiosInstance.patch(
        `family_members/${memberId}/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      toast.success(`${name} records updated successsfully!`, {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      return { data: response.data }
    } catch (error) {
      toast.error('Error updating family member records', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      return { error: error.response?.data?.detail }
    }
  }

  // Delete family member
  async deleteFamilyMember(memberId) {
    try {
      const response = await axiosInstance.delete(`family_members/${memberId}/`)
      toast.success('Family member successsfully!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      return { data: response.data }
    } catch (error) {
      toast.error('Error deleting family member', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { error: error.response?.data?.detail }
    }
  }
  //============================================================
  //Client family member files
  async fetchFamilyMemberFiles(memberId) {
    try {
      const response = await axiosInstance.get(
        `family_members/${memberId}/files`
      )
      return { data: response.data }
    } catch (error) {
      console.error('Error fetching family member file', error)
      return { error: error.response?.data?.detail || 'Error fetching files' }
    }
  }

  //============================================================
  // Delete a particular client

  // Program section
  // Fetch all programs
  async fetchAllPrograms() {
    try {
      const response = await axiosInstance.get('programs/') // Adjust if needed
      return { data: response.data }
    } catch (error) {
      console.error('Error fetching programs:', error)
      return {
        error: error.response?.data?.detail || 'Error fetching programs',
      }
    }
  }

  // Add program
  async addProgram(name, image, new_code) {
    const formData = new FormData()
    formData.append('name', name)
    if (new_code) {
      formData.append('new_code', new_code)
    }
    if (image) {
      formData.append('image', image)
    }
    try {
      const response = await axiosInstance.post('programs/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      toast.success('Program added successfully!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { data: response.data }
    } catch (error) {
      toast.error('Error adding program!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { error: error.response?.data?.detail }
    }
  }

  // Update program
  async updateProgram(programId, name, new_code, image) {
    const formData = new FormData()
    formData.append('name', name)
    formData.append('new_code', new_code)
    if (image) {
      formData.append('image', image)
    }
    try {
      const response = await axiosInstance.put(
        `programs/${programId}/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      toast.success('Program updated successfully!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { data: response.data }
    } catch (error) {
      toast.error('Error updating program!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { error: error.response?.data?.detail }
    }
  }

  // Delete program
  async deleteProgram(programId) {
    try {
      const response = await axiosInstance.delete(`programs/${programId}/`)
      toast.success('Program deleted successfully!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { data: response.data }
    } catch (error) {
      toast.error('Error deleting program!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { error: error.response?.data?.detail }
    }
  }
  //============================================================
  //Client family member files
  // eslint-disable-next-line no-dupe-class-members
  async fetchFamilyMemberFiles(memberId) {
    try {
      const response = await axiosInstance.get(
        `family_members/${memberId}/files`
      )
      return { data: response.data }
    } catch (error) {
      console.error('Error fetching family member file', error)
      return { error: error.response?.data?.detail || 'Error fetching files' }
    }
  }
  // upload files to root
  async uploadFile(memberId, file) {
    const formData = new FormData()
    formData.append('family_member', memberId)
    if (file) {
      formData.append('file', file)
    }
    try {
      const response = await axiosInstance.post(
        `family_members/${memberId}/files/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      toast.success('File uploaded successfully!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      console.log('File uploaded successfully!')
      return { data: response.data }
    } catch (error) {
      toast.error('Error uploading file!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { error: error.response?.data?.detail || 'file upload error' }
    }
  }

  // Upload files to folders
  async uploadFileToFolder(memberId, folderId, file) {
    const formData = new FormData()
    formData.append('family_member', memberId)
    formData.append('folder', folderId)
    if (file) {
      formData.append('file', file)
    }
    try {
      const response = await axiosInstance.post(
        `family_members/${memberId}/folders/${folderId}/files/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      toast.success('File uploaded successfully!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      console.log('File uploaded successfully!')
      return { data: response.data }
    } catch (error) {
      toast.error('Error uploading file!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { error: error.response?.data?.detail || 'file upload error' }
    }
  }

  // update file count in folder
  async updateFileCount(memberId, folderId, count) {
    const formData = new FormData()
    formData.append('required_num_of_file', count)
    try {
      const response = axiosInstance.patch(
        `family_members/${memberId}/folders/${folderId}/`,
        formData
        // {
        //   headers: {
        //     'Content-Types': 'application/json',
        //   },
        // }
      )
      if (response.data) {
        toast.success('required count updated successfully', {
          position: 'top-right',
          autClose: 3000,
          theme: 'colored',
        })
      }
      console.log('Hello people')
      return { data: response.data }
    } catch (error) {
      toast.error(`${error.response?.data?.detail}`, {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      return { error: error.response?.data?.detail }
    }
  }

  // update folder
  // update file count in folder
  async updateFolder(memberId, folderId, name, count) {
    const formData = new FormData()
    formData.append('name', name)
    formData.append('required_num_of_file', count)
    try {
      const response = axiosInstance.patch(
        `family_members/${memberId}/folders/${folderId}/`,
        formData,
        {
          headers: {
            'Content-Types': 'application/json',
          },
        }
      )
      toast.success('Folder updated successfully', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      return { data: response.data }
    } catch (error) {
      toast.error('Error updating folder', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      console.log(error.response?.data?.detail)
      return { error: error.response?.data?.detail }
    }
  }

  // Rename/Update file in folder
  async renameFileInFolder(memberId, folderId, fileId, newName) {
    console.log('Renaming file:', { memberId, folderId, fileId, newName })
    try {
      const response = await axiosInstance.patch(
        `family_members/${memberId}/folders/${folderId}/files/${fileId}/`,
        { name: newName },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      console.log('File renamed successfully!', response.data)
      toast.success('File renamed successfully', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { data: response.data }
    } catch (error) {
      console.error('Error renaming file', error)
      console.error('Error response:', error.response?.data)
      toast.error('Error renaming file!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { error: error.response?.data || 'Error renaming file' }
    }
  }

  // Rename/Update root file (not in folder)
  async renameFile(memberId, fileId, newName) {
    console.log('Renaming root file:', { memberId, fileId, newName })
    try {
      const response = await axiosInstance.patch(
        `family_members/${memberId}/files/${fileId}/`,
        { name: newName },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      console.log('Root file renamed successfully!', response.data)
      toast.success('File renamed successfully', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { data: response.data }
    } catch (error) {
      console.error('Error renaming root file', error)
      console.error('Error response:', error.response?.data)
      toast.error('Error renaming file!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { error: error.response?.data || 'Error renaming file' }
    }
  }

  // Delete root files
  async deleteFile(memberId, fileId) {
    try {
      const response = await axiosInstance.delete(
        `family_members/${memberId}/files/${fileId}/`
      )
      toast.success('File deleted successfully', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { data: response.data }
    } catch (error) {
      console.error('Error deleting file', error)
      toast.error('Error in deleting file!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { error: error.response?.data?.detail || 'Error deleting file' }
    }
  }

  // Delete Folder files
  async deleteFolderFile(memberId, folderId, fileId) {
    try {
      const response = await axiosInstance.delete(
        `family_members/${memberId}/folders/${folderId}/files/${fileId}/`
      )
      toast.success('File deleted successfully', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { data: response.data }
    } catch (error) {
      console.error('Error deleting folder file', error)
      toast.error('Error in deleting file!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return {
        error: error.response?.data?.detail || 'Error deleting folder file',
      }
    }
  }

  // async renameFile(memberId, folderId, fileId, newName) {
  //   const formData = new FormData()
  //   formData.append('name', newName)
  //   try {
  //     const response = await axiosInstance.patch(
  //       `family_members/${memberId}/folders/${folderId}/files/${fileId}/`,
  //       formData,
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //       }
  //     )
  //     return { data: response.data }
  //   } catch (error) {
  //     return { error: error.response?.data?.detail }
  //   }
  // }

  // Update folder
  // async renameFolder(memberId, folderId, name) {
  //   const formData = new FormData()
  //   formData.append('id', folderId)
  //   formData.append('name', name)
  //   formData.append('family_member', memberId)
  //   try {
  //     const response = await axiosInstance.put(
  //       `family_members/${memberId}/folders/${folderId}`,
  //       formData,
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //       }
  //     )
  //     if (response.data) {
  //       return { data: response.data }
  //     }
  //   } catch (error) {
  //     return { error: error.response?.data?.detail }
  //   }
  // }
  //============================================================
  // Client family member folders
  async fetchFamilyMemberFolders(memberId) {
    try {
      const response = await axiosInstance.get(
        `family_members/${memberId}/folders/root/`
      )
      return { data: response.data }
    } catch (error) {
      console.error('Error fetching family member file', error)
      return { error: error.response?.data?.detail || 'Error fetching files' }
    }
  }
  // Family member folder files
  async fetchFamilyFolderFiles(memberId, folderId) {
    try {
      const response = await axiosInstance.get(
        `family_members/${memberId}/folders/${folderId}/files/`
      )
      return { data: response.data }
    } catch (error) {
      console.error('Error fetching family member folder files', error)
      return {
        error:
          error.response?.data?.detail ||
          'Error fetching family member folder files',
      }
    }
  }
  async fetchFamilySubfolders(memberId, folderId) {
    try {
      const response = await axiosInstance.get(
        `family_members/${memberId}/folders/${folderId}/subfolders/`
      )
      return { data: response.data }
    } catch (error) {
      return { error: error.response?.data?.detail || 'folder not found' }
    }
  }

  // Create folder
  async createFamilyFolders(memberId, folderName, fileCount) {
    const formData = new FormData()
    formData.append('name', folderName)
    formData.append('family_member', memberId)
    formData.append('required_num_of_file', fileCount)
    try {
      const response = await axiosInstance.post(
        `family_members/${memberId}/folders/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      console.log('Folder created successfully', response.data)
      toast.success('Folder created successfully!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { data: response.data || 'folder created successfully' }
    } catch (error) {
      toast.error('Error  creating folder!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      console.error('Error creating family folder', error)
      return { error: error.response?.data?.detail || 'Error creating folder' }
    }
  }

  // Family member sub folders
  async createFamilySubFolders(memberId, folderId, folderName, fileCount) {
    const formData = new FormData()
    formData.append('name', folderName)
    formData.append('family_member', memberId)
    formData.append('id', folderId)
    formData.append('required_num_of_file', fileCount)
    console.log('create subfolder', formData)
    try {
      const response = await axiosInstance.post(
        `family_members/${memberId}/folders/${folderId}/subfolders/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      toast.success('Folder created successfully!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      console.log('Folder created successfully', response.data)
      return { data: response.data || 'Subfolder created successfully!' }
    } catch (error) {
      toast.error('Error in creating folder!', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      console.log('Error creating subfolder', error)
      return {
        error: error.response?.data?.detail || 'Error creating subfolder',
      }
    }
  }

  // Rename folder
  async renameFolder(memberId, folderId, newName) {
    console.log('Renaming folder:', { memberId, folderId, newName })
    try {
      const response = await axiosInstance.patch(
        `family_members/${memberId}/folders/${folderId}/`,
        { name: newName },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      console.log('Folder renamed successfully!', response.data)
      toast.success('Folder renamed successfully', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })
      return { data: response.data }
    } catch (error) {
      console.error('Error response:', error.response?.data?.detail)
      toast.error('Error renaming folder', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { error: error.response?.data?.detail || 'Error renaming folder' }
    }
  }

  // Delete Folder
  async deleteFolder(memberId, folderId) {
    try {
      const response = await axiosInstance.delete(
        `family_members/${memberId}/folders/${folderId}/`
      )
      toast.success('Folder deleted successfully', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return { data: response.data }
    } catch (error) {
      console.error('Error deleting root folder')
      toast.error('Error deleting folder', {
        position: 'top-right',
        autClose: 3000,
        theme: 'colored',
      })

      return {
        error: error.response?.data?.detail,
      }
    }
  }
  // Upload family member files
  // async uploadFamilyMemberFile(){
  //   try {
  //     const response = await axiosInstance.get(`family`)
  //   }catch (error) {
  //     console.error('Error uploading file', error)
  //     return {error: error.response?.data?.detail || 'Error uploading file'}
  //   }
  // }
  async fetchSummary(clientId) {
    try {
      const response = await axiosInstance.get(`clients/${clientId}/summary/`)
      return { data: response.data }
    } catch (error) {
      return { error: error.response?.data?.detail }
    }
  }
}

export default ApiClient
